import { DataService } from '../../services/data.service';
import { observable, action, } from 'mobx';
import { Injectable } from '@angular/core';
import { ILevel, IGrammarInUseContent, IPlacementTest, IPlacementTestClass, IGeneralPlacementTest } from 'src/app/interfaces/resource';
import * as firebase from 'firebase/app';
import { pushToObject, orderBy } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';

@Injectable()
export class PlacementTest {
    @observable data: any[] = [];
    @observable process: boolean = false;
    @observable loading: boolean = true;
    @observable empty: boolean = false;
    @observable lastVisible: any = null;
    @observable fetching: boolean = false;

    constructor(private ds: DataService) { }

    @action
    fetchQuestion(questionKey, testTypeKey, skillKey, callback) {
        this.ds.placementTestRef().doc(skillKey).collection(`${testTypeKey}`).doc(questionKey).valueChanges().subscribe(doc => {
            callback(doc)
        })
    }

    @action
    fetchExercise(skillKey,classKey) {
        this.loading = true;
        this.ds.generalPlacementTestRef().doc(classKey).collection(skillKey,ref=>ref.orderBy('page_key')).valueChanges().subscribe(docs => {
            this.data = docs;
            this.empty = docs.length === 0;
            this.loading = false;
        })
    }

    @action
    fetchClass() {
        this.loading = true;
        this.ds.generalPlacementTestRef().valueChanges().subscribe(docs => {
            this.data = docs;
            this.empty = docs.length === 0;
            this.loading = false;
        })
    }

    @action
    fetchGeneralPlacementQuestion(classKey,skillKey,questionKey, callback) {
        this.ds.generalPlacementTestRef().doc(classKey).collection(`${skillKey}`).doc(questionKey).valueChanges().subscribe(doc => {
            callback(doc)
        })
    }

    @action
    async fetchClassTesting(key){
       return pushToObject(await this.ds.generalPlacementTestRef().doc(key).get().toPromise())
    }

    @action
    fetchData(skillKey, testTypeKey) {
        this.loading = true;
        this.ds.placementTestRef().doc(skillKey).collection(`${testTypeKey}`).valueChanges().subscribe(docs => {
            this.data = docs;
            this.empty = docs.length === 0;
            this.loading = false;
        })
    }

    @action
    addItem(item: IPlacementTest, callback) {
        this.process = true;
        this.ds.placementTestRef().doc(item.skillKey).collection(`${item.testingTypeKey}`).doc(item.key).set(item).then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    addMCQ(item: IGeneralPlacementTest, callback) {
        this.process = true;
        this.ds.generalPlacementTestRef().doc(item.classKey).collection(`${item.skillKey}`).doc(item.key).set(item).then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    updateActivitySoundURL(item: IPlacementTest, url, uid, callback) {
        this.process = true;
        this.ds.placementTestRef().doc(item.skillKey).collection(`${item.testingTypeKey}`).doc(item.key).update({
            soundDownloadURL: url,
            updated_at: new Date(),
            updated_by: uid,
            updated_byRef: this.ds.userProfileRef().doc(uid).ref,
        }).then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    save(item: IPlacementTestClass, callback) {
        this.process = true;
        this.ds.generalPlacementTestRef().doc(item.key).set(item).then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

}
